import React from "react";
import Container from "../Container/Container";
import "./AboutMeSection.css";

const AboutMeSection = () => {
    return <Container>
        <section className="about-me-section" id="about">
            <div className="about-me-header">
                <h1>About Me</h1>
            </div>
            <div className="about-me-content">
                <div className="about-me-image">
                    <img src="handstand.webp" alt="Dustin Graham" />
                </div>
                <div className="about-me-body">
                    <h2>Creator. Problem Solver. Engineer.</h2>
                    <p>
                        I’m a software engineer and product builder focused on creating scalable, real world web platforms. I specialize in modern applications built with TypeScript, React, Next.js, and serverless AWS infrastructure, designing systems that are fast, reliable, and genuinely useful.
                    </p>
                    <p>
                        At my core, I love creating things and solving problems. I enjoy taking complex ideas, breaking them down, and building solutions that make life simpler and more efficient.
                    </p>
                    <p>
                        Outside of engineering, I train in calisthenics and spend as much time in nature as I can, especially hiking and exploring the outdoors. Both reflect the mindset I bring to my work: consistency, curiosity, and continuous growth.
                    </p>
                </div>
            </div>
        </section>
    </Container>;
};

export default AboutMeSection;